import { Label, Select } from "flowbite-react";
import { useState, useContext, useMemo } from "react";
import { useAuth } from "react-oidc-context";
import { SportsMapInv } from "../pages/SportMap";
import { AthleteFormContext } from "./FormData";

export function AthleteProfileForm() {
  const auth = useAuth();

  const formData = useContext(AthleteFormContext);

  // Get a list of Sports

  const [teamList, setTeamList] = useState(null);
  const t = useMemo(() => {
    if (
      formData.sport !== null &&
      formData.div !== null &&
      formData.conf !== null
    ) {
      return fetch(
        `/api/team?sport=${formData.sport}&div=${formData.div}&conf=${formData.conf}`,
        {
          method: "get",
          headers: {
            "content-type": "application/json",
            authorization: `bearer ${auth.user.access_token}`,
          },
        }
      )
        .then((resp) => {
          if (!resp.ok) {
            throw new error("could not get team list");
          }
          return resp.json();
        })
        .then((resp) => setTeamList(resp));
    }
  }, [formData.conf, formData.div, formData.sport]);

  // Get a list of players in team
  const [playerList, setPlayerList] = useState(null);
  const p = useMemo(() => {
    if (formData.team !== null) {
      return fetch(`/api/team/${formData.team}?by_filter=UNVERIFIED`, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${auth.user.access_token}`,
        },
      })
        .then((resp) => {
          if (!resp.ok) {
            throw new Error("Could not get team info");
          }
          return resp.json();
        })
        .then((resp) => {
          setPlayerList(resp.roster);
        });
    }
  }, [formData.team]);

  // Sports Drop Down Component
  const SportsDropDown = () => {
    return (
      <>
        <Label htmlFor="sport" value="Select your Sport" />
        <Select
          id="sport"
          required
          onChange={(e) => {
            formData.setSport(e.target.value);
          }}
          value={formData.sport}
        >
          <option hidden>- Select Sport -</option>
          {formData.sportList !== null ? (
            formData.sportList.map((sport) => {
              return <option value={sport}>{SportsMapInv[sport]}</option>;
            })
          ) : (
            <></>
          )}
        </Select>
      </>
    );
  };

  // Conference Drop Down Component
  const ConferenceDropDown = () => {
    return (
      <>
        <Label htmlFor="conference" value="Select your Conference" />
        <Select
          id="conference"
          onChange={(e) => {
            formData.setConf(e.target.value);
          }}
          value={formData.conf}
        >
          <option hidden>- Select Conference -</option>
          {formData.confList !== null ? (
            formData.confList.map((conf) => {
              return <option>{conf}</option>;
            })
          ) : (
            <></>
          )}
        </Select>
      </>
    );
  };

  // Division Drop Down Component
  const DivisionDropDown = () => {
    return (
      <>
        <Label htmlFor="division" value="Select your Division" />
        <Select
          id="division"
          onChange={(e) => {
            formData.setDiv(e.target.value);
          }}
          value={formData.div}
        >
          <option hidden>- Select Division -</option>
          {formData.divList !== null ? (
            formData.divList.map((div) => {
              return <option>{div}</option>;
            })
          ) : (
            <></>
          )}
        </Select>
      </>
    );
  };

  const TeamDropDown = () => {
    return (
      <>
        {teamList !== null ? (
          <>
            <Label htmlFor="team" value="Select your Team" />
            <Select
              id="team"
              onChange={(e) => {
                formData.setTeam(e.target.value);
                formData.setTeamName(e.target[e.target.selectedIndex].text);
              }}
              value={formData.team}
            >
              <option hidden>- Select Team -</option>
              {teamList?.map((team) => {
                return <option value={team.nilo_id}>{team.name}</option>;
              })}
            </Select>
          </>
        ) : (
          <></>
        )}
      </>
    );
  };

  const PlayerDropDown = () => {
    return playerList !== null ? (
      <>
        <Label htmlFor="player" value="Choose your Profile" />
        <Select
          id="player"
          onChange={(e) => {
            formData.setNiloID(e.target.value);
          }}
          value={formData.niloID}
        >
          <option hidden>- Select Player -</option>
          {playerList.map((player) => {
            return <option value={player.nilo_id}>{player.name}</option>;
          })}
        </Select>
      </>
    ) : (
      <></>
    );
  };

  return (
    <>
      <SportsDropDown />
      <ConferenceDropDown />
      <DivisionDropDown />
      <TeamDropDown />
      <PlayerDropDown />
    </>
  );
}
